import { AxiosPromise } from 'axios';

import { BillsBillChargeTypesResponse, BillsBillImageTypesResponse } from './types';
import { baseClientConstructorProps } from '../config';
import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../generated/baseClient';

class SettlementTypesClient extends BaseClient {
  private _namespace: string;

  constructor(props: BaseClientConstructorProps) {
    super(props);

    this._namespace = '/api/v1/settlement/types';
  }

  readonly getChargeTypes = (): AxiosPromise<BillsBillChargeTypesResponse> => {
    const sendRequestPayload: SendRequestPayload = {
      endpoint: `${this._namespace}/charge_types`,
      method: 'GET',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };

  readonly getImageTypes = (): AxiosPromise<BillsBillImageTypesResponse> => {
    const sendRequestPayload: SendRequestPayload = {
      endpoint: `${this._namespace}/image_types`,
      method: 'GET',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };
}

export const settlementTypesClient = new SettlementTypesClient(baseClientConstructorProps);
